"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _calendar = _interopRequireDefault(require("cccisd-icons/calendar"));
var _SelectGroups = _interopRequireDefault(require("./SelectGroups"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  startDate: {
    label: 'Start date',
    component: function component(_ref) {
      var settings = _ref.settings;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "startDate",
        component: _cccisdFormik.CccisdDatepicker,
        label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, settings.label, " ", /*#__PURE__*/_react["default"].createElement(_calendar["default"], null))
      });
    }
  },
  endDate: {
    label: 'End date',
    component: function component(_ref2) {
      var settings = _ref2.settings;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "endDate",
        component: _cccisdFormik.CccisdDatepicker,
        label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, settings.label, " ", /*#__PURE__*/_react["default"].createElement(_calendar["default"], null))
      });
    }
  },
  groupIds: {
    label: 'Select groups',
    component: function component(props) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "groupIds"
      }, function (_ref3) {
        var field = _ref3.field,
          form = _ref3.form;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
          field: field,
          form: form
        }, /*#__PURE__*/_react["default"].createElement(_SelectGroups["default"], {
          field: field,
          form: form,
          settings: props.settings,
          reportHandle: props.reportHandle,
          userType: props.userType
        }));
      });
    }
  }
};